// ClearButton.js
import React from 'react';
import styles from './ClearButton.module.css';

const ClearButton = ({ text, onClick }) => {
  return (
    <button className={styles.clearButton} onClick={onClick}>
      {text}
    </button>
  );
};

export default ClearButton;